import { useEffect } from 'react';

interface ScrollEventHandler {
  (event: Event): void;
}

const useScrollListener = (handler: ScrollEventHandler) => {
  useEffect(() => {
    const scrollListener = (event: Event) => {
      handler(event); // Call the passed handler
    };

    // Add the scroll event listener to the document in the capture phase
    document.addEventListener('scroll', scrollListener, { capture: true });

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('scroll', scrollListener, { capture: true });
    };
  }, [handler]); // Dependency array ensures handler updates if changed
};

export default useScrollListener;
